import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/grid.css";
import "./assets/css/index.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(<App />, document.getElementById("root"));
serviceWorkerRegistration.register();
reportWebVitals();
